import i18next from 'i18next';
import { getLang, setLang, langsArr, setTranslates } from '../../utils/translate-module';

{
  changeHeaderOnScroll();
  window.addEventListener('scroll', () => {
    changeHeaderOnScroll();
  });

  function changeHeaderOnScroll() {
    const header = document.querySelector('.js-header');
    if (window.scrollY > 10) {
      header.classList.add('on-scroll');
    } else {
      header.classList.remove('on-scroll');
    }
  }
};

// logic for menu on mobile
{
  const showNav = document.querySelector('.js-show-mob-nav');
  const nav = document.querySelector('.js-header-nav');
  const body = document.querySelector('body');
  let isNavOpened = false;
  showNav.addEventListener('click', () => {
    isNavOpened = !isNavOpened;
    nav.classList.toggle('visible');
    body.classList.toggle('overflow-hidden');
    showNav.classList.toggle('active');
  });
  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 768px)').matches && isNavOpened) {
      isNavOpened =  false;
      nav.classList.remove('visible');
      body.classList.remove('overflow-hidden');
      showNav.classList.remove('active');
    }
  });
}

// logic for translating

{
  const lang = getLang();
  const openList = document.querySelector('.js-lang');
  const list = document.querySelector('.js-lang-list');
  changeLang(lang);

  // set selected lang
  function changeLang(lang) {
    while (list.hasChildNodes()) {
      list.removeChild(list.lastChild);
    }

    const langsToChange = langsArr.filter((l) => l !== lang);
    langsToChange.forEach((l) => {
      list.appendChild(renderLangItem(l));
    });
    openList.innerText = lang;
    i18next.changeLanguage(lang, (err, t) => {
      if (err) {
        return console.log('something went wrong loading', err);
      }

      setTranslates(t, lang);
    });

    openList.innerText = lang;
    if (getLang() !== lang) {
      setLang(lang);
    }
  }

  // rendering language list
  function renderLangItem(lang) {
    const li = document.createElement('li');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.innerText = lang.toUpperCase();
    li.appendChild(btn);
    btn.addEventListener('click', () => changeLang(lang));
    return li;
  }
};